/* MARMOT F2 — попъп за избор на доставка в количката (заменя middleware.bg).
   Дизайн „Колетът": динамичен поток (Подарък при наличност → Данни → Доставка →
   Потвърждение) + винаги видим опаковъчен фиш. Vanilla, defer, без библиотеки.

   Чистата логика (нулиране при смяна на метод — §4.1, праг за безплатна
   доставка, валута, навигация) е в marmot-delivery-logic.js (window.MarmotF2Logic),
   за да е тестима без браузър. Този файл е DOM обвивката около нея.

   Активира се САМО когато Editera backend config-ът върне enabled:true
   (истинският kill switch) или при ?f2_preview=1 (визуален преглед в
   непубликувана тема). Иначе снипетът стои скрит и стандартният checkout
   не се пипа — нула клиентски промени, докато middleware е активен.

   Поток: количка → попъп → POST /api/shopify/checkout/draft → redirect към
   invoiceUrl. Валидацията тук огледалва shopifyCheckoutService.validateCheckoutDraft.
   buildRequest() пази заварения контракт срещу #D774; подаръкът е единствено
   отделното незадължително поле giftVariantId и никога не влиза в lines. */
(function () {
  'use strict';

  var L = window.MarmotF2Logic;
  var CONFIG_VERSION = 1;
  var memoryF2SessionId = null;

  // Колко офиса теглим наведнъж за ЕДИН град. Големите градове се събират цели
  // (София е най-големият случай); ендпойнтът има свой таван и връща total.
  var CITY_OFFICE_LIMIT = 500;

  // Само ВИДИМИ етикети – живеят в логическия модул, за да са под тест.
  // Заглавието на shipping line-а се строи от бекенда, тук НЕ се пипа.
  // Резервът са заварените три етикета: стар логически файл от кеша не бива
  // да покаже суров ключ „speedy:office" (BOX NOW тогава просто няма етикет).
  var METHOD_LABELS = (L && L.METHOD_LABELS) || {
    'speedy:office': 'До офис или автомат на Speedy',
    'speedy:address': 'До личен адрес',
    'econt:office': 'До офис или еконтомат на Еконт'
  };

  // §4.4: етикетът на стъпка казва какво е стъпката, без чар.
  var STEP_TITLES = {
    gift: 'Избери подарък',
    details: 'Данни за поръчката',
    delivery: 'Доставка',
    review: 'Потвърждение'
  };

  var ERROR_MESSAGES = {
    CHECKOUT_DISABLED: 'Онлайн поръчката е временно недостъпна. Опитай отново по-късно или се свържи с нас.',
    // Недостижимо от 28.07.2026 – сървърът вече не връща този код (границата е
    // решена). Оставено нарочно като застраховка при rollback на библиотеката.
    FREE_SHIPPING_BOUNDARY_NOT_CONFIGURED: 'Има технически проблем с цената на доставката за тази сума. Свържи се с нас, за да завършим поръчката.',
    OFFICE_NOT_FOUND: 'Избраният офис вече не е наличен. Избери друг офис.',
    OFFICE_CACHE_EMPTY: 'Списъкът с офиси временно не е наличен. Опитай пак след малко.',
    IDEMPOTENCY_CONFLICT: 'Количката се промени. Прегледай данните и опитай пак.',
    ATTEMPT_IN_PROGRESS: 'Заявката вече се обработва. Изчакай момент и провери имейла си.',
    ATTEMPT_UNKNOWN: 'Заявката може вече да е приета. Провери имейла си, преди да опиташ отново.',
    SERVER_ERROR: 'Възникна грешка. Опитай отново след малко.',
    DRAFT_CREATE_FAILED: 'Не успяхме да създадем поръчката. Опитай отново след малко.',
    RATE_LIMITED: 'Твърде много опити. Изчакай малко и опитай пак.',
    NETWORK: 'Няма връзка със сървъра. Провери интернета и опитай пак.',
    PROMO_REJECTED: 'Кодът не е валиден за тази количка.',
    // Попъпът не е получил количката (/cart.js не е отговорил). Без нея няма
    // какво да се поръча: по-добре ясна молба, отколкото общото „Възникна грешка".
    CART_UNAVAILABLE: 'Не успяхме да заредим количката. Презареди страницата и опитай пак.',
    INVALID_LINES: 'Не успяхме да заредим количката. Презареди страницата и опитай пак.'
  };

  function init(root) {
    if (root.dataset.marmotInit === '1') return;
    root.dataset.marmotInit = '1';
    if (!L) return; // логическият модул трябва да е зареден преди този файл

    var store = (root.dataset.store || '').trim();
    var apiBase = (root.dataset.apiBase || '').replace(/\/+$/, '');
    if (!store || !apiBase) return;

    var params = new URLSearchParams(window.location.search);
    var previewForce = params.get('f2_preview') === '1';
    try {
      if (previewForce) sessionStorage.setItem('f2_preview', '1');
      else if (sessionStorage.getItem('f2_preview') === '1') previewForce = true;
    } catch (e) {}
    var forceActive = root.dataset.forceActive === '1';

    apiGet(apiBase + '/api/shopify/checkout/config?store=' + encodeURIComponent(store))
      .then(function (cfg) {
        if (!cfg || typeof cfg !== 'object') return;
        var active = cfg.enabled === true || previewForce || forceActive;
        if (!active) return; // дормантно — стандартният checkout остава
        // Ключът на темата „Подарък при поръчка" е над Editera: изключен ли е,
        // giftEnabled става false и оттук надолу няма клас, заявки и стъпка.
        // Стар логически файл от кеша (без функцията) = изключено, не включено.
        cfg = L.applyThemeGiftSwitch
          ? L.applyThemeGiftSwitch(cfg, root.dataset.giftOn)
          : Object.assign({}, cfg, { giftEnabled: false });
        // Обявяването в количката върви със същия гейт: няма ли попъп, няма къде
        // да се избере подарък, тоест няма и какво да се обещава.
        if (cfg.giftEnabled === true) document.documentElement.classList.add('marmot-gift-on');
        // Скрит BOX NOW: само при ?f2_boxnow=1 в адреса, без storage (решение 1
        // на брифа boxnow-skrit-b). Стар логически файл от кеша = списъкът както днес.
        if (L.visibleMethods) {
          cfg = Object.assign({}, cfg, { methods: L.visibleMethods(cfg, window.location.search) });
        }
        new Widget(root, cfg, apiBase, store, (previewForce || forceActive) && cfg.enabled !== true);
      })
      .catch(function () { /* fail closed */ });
  }

  /* ---- Widget ---- */

  function Widget(root, cfg, apiBase, store, isPreview) {
    this.root = root;
    this.cfg = cfg;
    this.apiBase = apiBase;
    this.store = store;
    this.isPreview = isPreview;

    this.dialog = root.querySelector('[data-f2-dialog]');
    this.overlay = root.querySelector('[data-f2-overlay]');
    this.form = root.querySelector('[data-f2-form]');
    this.titleEl = root.querySelector('[data-f2-title]');
    this.rail = root.querySelector('[data-f2-rail]');
    this.methodsBox = root.querySelector('[data-f2-methods]');
    this.officeBox = root.querySelector('[data-f2-office]');
    this.cityInput = root.querySelector('[data-f2-city-q]');
    this.cityList = root.querySelector('[data-f2-city-list]');
    this.officeField = root.querySelector('[data-f2-office-field]');
    this.officeInput = root.querySelector('[data-f2-office-q]');
    this.officeList = root.querySelector('[data-f2-office-list]');
    this.officeHint = root.querySelector('[data-f2-office-hint]');
    this.foot = root.querySelector('.marmot-f2__foot');
    this.addressBox = root.querySelector('[data-f2-address]');
    this.addrCityInput = root.querySelector('[data-f2-addr-city]');
    this.addrCityList = root.querySelector('[data-f2-addr-city-list]');
    this.addrStreetField = root.querySelector('[data-f2-addr-street-field]');
    this.addrStreetInput = root.querySelector('[data-f2-addr-street]');
    this.addrStreetList = root.querySelector('[data-f2-addr-street-list]');
    this.addrDetails = root.querySelector('[data-f2-addr-details]');
    this.addrLookup = root.querySelector('[data-f2-addr-lookup]');
    this.addrFallbackBox = root.querySelector('[data-f2-addr-fallback]');
    this.backBtn = root.querySelector('[data-f2-back]');
    this.cta = root.querySelector('[data-f2-cta]');
    this.ctaLabel = root.querySelector('[data-f2-cta-label]');
    this.stepOf = root.querySelector('[data-f2-stepof]');
    this.formError = root.querySelector('[data-f2-form-error]');
    this.itemsToggle = root.querySelector('[data-f2-items-toggle]');
    this.linesBox = root.querySelector('[data-f2-lines]');
    this.promoApply = root.querySelector('[data-f2-promo-apply]');
    this.promoInput = root.querySelector('#marmot-f2-promo');
    this.promoNoteEl = root.querySelector('[data-f2-promo-note]');
    this.giftsBox = root.querySelector('[data-f2-gifts]');
    this.skipGift = root.querySelector('[data-f2-skip-gift]');
    this.giftGoneEl = root.querySelector('[data-f2-gift-gone]');
    this.giftIntro = root.querySelector('[data-f2-gift-intro]');
    // Текстът е съдържание на снипета, не на скрипта; пазим го, за да можем да
    // го върнем, след като сме го сменили при опразнен списък.
    this.giftIntroText = this.giftIntro ? this.giftIntro.textContent : '';

    this.state = {
      step: 1,
      courier: null,
      service: null,
      discountCache: null,
      officeId: null,
      officeLabel: null,
      officeType: null,
      cityName: null,
      cityZip: null,
      addrSiteId: null,
      addrSiteName: null,
      addrZip: null,
      addrPick: null, // { kind: 'street'|'complex', id, name, prefix } – виж L.addrSuggestions
      addrFallback: false,
      promo: '',
      discount: null,
      promoChecking: false,
      promoCoolingDown: false,
      promoFailures: 0,
      promoWasChecked: false,
      idempotencyKey: null,
      cart: null,
      gifts: [],
      giftVariantId: null,
      giftStepEnabled: false,
      readyInvoiceUrl: null,
      readyBody: null,
      open: false,
      metaCheckoutOpenSeq: 0,
      metaCheckoutPublishedSeq: 0,
      oaiCheckoutPublishedSeq: 0,
      submitting: false,
      itemsOpen: root.dataset.itemsOpen === '1',
      lastFocus: null
    };
    this.officeSearchTimer = null;
    this.officeSearchSeq = 0;
    this.cityOffices = [];
    this.cityOfficesTruncated = false;
    this.addrCityTimer = null;
    this.addrCitySeq = 0;
    this.addrStreetTimer = null;
    this.addrStreetSeq = 0;
    this.promoCheckSeq = 0;
    this.promoCooldownTimer = null;
    this.promoRecheckPending = false;
    this.giftsLoading = false;

    var termsLink = root.querySelector('[data-f2-terms-link]');
    if (termsLink && cfg.termsUrl) termsLink.setAttribute('href', cfg.termsUrl);

    this.renderMethods();
    this.bindCheckoutInterception();
    this.bindPopupControls();
    this.bindFormBehaviour();
    this.updateStepUI();
    this.updateSummary();
    this.loadGifts();
    this.loadGiftBase();
    this.syncGiftThresholdText();

    document.documentElement.classList.add('has-marmot-f2');
    if (isPreview) this.showFormError('Тестов режим (?f2_preview=1): попъпът е видим, но реална поръчка не се създава, докато kill switch-ът е изключен.');
  }

  /* ---- Подарък по избор ---- */

  /* Заявката тръгва след config-а и ПАК при всяко отваряне: наличността мърда с
     всяка поръчка, а попъпът живее колкото страницата. Без пресвеждане занулено
     заглавие стои в избора до презареждане.

     Пристигналият списък сменя СЪДЪРЖАНИЕТО на стъпката, но никога БРОЯ на
     стъпките: `giftStepEnabled` се замразява при отваряне и потокът не сменя
     формата си под ръката на човека. Отказът не изпразва списъка — сървърът има
     свой кеш, а стар списък е по-добър от изчезнала стъпка; изчерпаното заглавие
     и без това пада при потвърждението (`giftApplied`). */
  Widget.prototype.loadGifts = function () {
    var self = this;
    if (this.cfg.giftEnabled !== true) return;
    if (this.giftsLoading) return;
    this.giftsLoading = true;
    apiGet(this.apiBase + '/api/shopify/checkout/gifts?store=' + encodeURIComponent(this.store))
      .then(function (response) {
        self.giftsLoading = false;
        var gifts = response && Array.isArray(response.gifts) ? response.gifts : [];
        var novi = gifts.filter(function (gift) {
          return gift && /^\d+$/.test(String(gift.variantId || '')) &&
            typeof gift.title === 'string' && !!gift.title.trim() &&
            typeof gift.image === 'string' && !!gift.image.trim();
        }).map(function (gift) {
          return {
            variantId: String(gift.variantId),
            title: gift.title.trim(),
            image: gift.image.trim()
          };
        });
        // Непроменен списък не пипа DOM-а. Пресвеждането при отваряне се връща,
        // докато човекът вече стои на подаръчната стъпка с фокус върху първото
        // radio — пререндер без промяна би му отнел фокуса без причина.
        var promyana = JSON.stringify(novi) !== JSON.stringify(self.state.gifts);
        self.state.gifts = novi;
        if (!promyana) return;
        // Избор, който вече го няма в списъка, пада тук: иначе пътува до сървъра
        // само за да се върне като giftApplied:false, при положение че знаем.
        if (self.state.giftVariantId && !self.selectedGift()) self.state.giftVariantId = null;
        var beshFokusiran = !!(self.giftsBox && self.giftsBox.contains(document.activeElement));
        self.renderGifts();
        if (beshFokusiran) {
          // Опразнен списък няма къде да върне фокуса освен на изхода; иначе
          // фокусът пада на <body> и излиза извън капана на диалога.
          var parvo = self.giftsBox.querySelector('input[name="f2gift"]') || self.skipGift;
          if (parvo) parvo.focus();
        }
        if (self.state.open && self.currentStepKey() === 'review') self.updateReview();
      })
      .catch(function () { self.giftsLoading = false; });
  };

  Widget.prototype.renderGifts = function () {
    var self = this;
    if (!this.giftsBox) return;
    this.giftsBox.innerHTML = '';
    /* Стъпката е замразена при отваряне, а пресвеждането може да я изпразни под
       ръката на човека. Празна група с покана „Избери книга" е задънена улица:
       текстът казва какво е станало, а изходът остава „Продължи без подарък". */
    if (this.giftIntro) {
      this.giftIntro.textContent = this.state.gifts.length
        ? this.giftIntroText
        : 'Подаръкът отпадна от тази поръчка. Продължи напред.';
    }
    this.state.gifts.forEach(function (gift, index) {
      var id = 'marmot-f2-gift-' + index;
      var option = document.createElement('label');
      option.className = 'marmot-f2__gift-option';
      option.setAttribute('for', id);

      var input = document.createElement('input');
      input.className = 'marmot-f2__gift-radio';
      input.type = 'radio';
      input.name = 'f2gift';
      input.id = id;
      input.value = gift.variantId;
      input.checked = self.state.giftVariantId === gift.variantId;
      input.addEventListener('change', function () {
        self.state.giftVariantId = gift.variantId;
      });

      var coverWrap = document.createElement('span');
      coverWrap.className = 'marmot-f2__gift-cover-wrap';
      var cover = document.createElement('img');
      cover.className = 'marmot-f2__gift-cover';
      // До 13 корици наведнъж на мобилен чекаут: искаме ги в мярка от CDN-а, а
      // не оригиналите. Размерите са известни предварително, за да не скачат
      // картите, докато картинките пристигат (съотношението е 2/3 и в CSS-а).
      cover.src = giftCoverUrl(gift.image, 320);
      cover.width = 320;
      cover.height = 480;
      cover.alt = '';
      cover.loading = 'eager';
      coverWrap.appendChild(cover);

      var title = document.createElement('span');
      title.className = 'marmot-f2__gift-title';
      title.textContent = gift.title;

      option.appendChild(input);
      option.appendChild(coverWrap);
      option.appendChild(title);
      self.giftsBox.appendChild(option);
    });
  };

  /* Shopify CDN приема `width` като параметър на заявката. Чужд адрес просто
     ще пренебрегне непознат параметър, тоест мярката не може да счупи корица. */
  function giftCoverUrl(url, width) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  Widget.prototype.selectedGift = function () {
    var selected = this.state.giftVariantId;
    if (!selected) return null;
    return this.state.gifts.filter(function (gift) { return gift.variantId === selected; })[0] || null;
  };

  /* Прагът иска сбора на количката ПРЕДИ отварянето: `giftStepEnabled` се
     замразява в `openPopup`, а `loadCart` отговаря чак след това. Затова тук се
     тегли само сборът, БЕЗ нито едно от следствията на `loadCart` — промокодът
     не се пипа и проверка не тръгва. Без това първото отваряне на всяка сесия
     винаги би съдило по непозната количка. */
  Widget.prototype.loadGiftBase = function () {
    var self = this;
    if (this.cfg.giftEnabled !== true) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        self.state.giftBaseCents = cart.items.reduce(function (sum, it) {
          return sum + (it.final_line_price || 0);
        }, 0);
      })
      .catch(function () { /* непознат сбор – стъпката не се гаси, вж. логиката */ });
  };

  /* Сборът в мига на замразяването, по реда на пресността.

     ПЪРВО DOM-ът: `data-marmot-cart-base` се рендерира от Liquid вътре в
     `js-contents-subtotal`, а темата презарежда точно този блок при всяка
     промяна на количката. Тоест числото е това, което човекът вижда на екрана
     в същата секунда — включително след добавяне от рафта в количката, което
     става БЕЗ презареждане на страницата.

     Защо не стига нищо друго: `state.cart` се пълни от `loadCart`, който в
     `openPopup` тръгва СЛЕД замразяването, тоест при първото отваряне е празен,
     а при всяко следващо носи количката от ПРЕДИШНОТО отваряне. Снимката от
     `loadGiftBase` пък е от зареждането на страницата. И двете са остарели точно
     в скъпия случай: количка за 15 €, книга от рафта, 25 € — и подаръкът да се
     отнеме тихо, защото прагът се е мерил по 1500.

     Двете стари стойности остават като резерва за страници без този възел. */
  Widget.prototype.giftBaseCents = function () {
    var el = document.querySelector('[data-marmot-cart-base]');
    if (el) {
      var suroro = parseInt(el.getAttribute('data-marmot-cart-base'), 10);
      if (isFinite(suroro) && suroro >= 0) return suroro;
    }
    var jiv = this.cartSubtotalCents();
    if (jiv !== null) return jiv;
    return typeof this.state.giftBaseCents === 'number' ? this.state.giftBaseCents : null;
  };

  /* Числото в подзаглавието идва от Editera, щом го е пратила: така показаният
     праг не може да се разминава с пазения. Настройката на темата остава
     резерва – тя рендерира изречението и без JavaScript. */
  Widget.prototype.syncGiftThresholdText = function () {
    var prag = Number(this.cfg.giftThresholdEur);
    if (!isFinite(prag) || prag < 0) return;
    var tekst = String(Math.round(prag * 100) % 100 === 0
      ? Math.round(prag)
      : (Math.round(prag * 100) / 100).toFixed(2).replace('.', ','));
    var el = this.root.querySelector('[data-f2-gift-threshold]');
    if (el) {
      // Първи повик: възелът още стои така, както Liquid го е нарисувал.
      if (el.textContent !== tekst) el.textContent = tekst;
      this.giftIntroText = this.giftIntro ? this.giftIntro.textContent : this.giftIntroText;
      this.giftThresholdText = tekst;
      return;
    }
    /* Възелът вече го няма: `renderGifts` присвоява `textContent` на целия
       абзац при опразнен списък и го изтрива. Затова числото се сменя в
       ЗАПАЗЕНИЯ текст, а не в DOM-а – иначе втори повик (обновен config) би
       мълчал и подзаглавието би останало със старото число. */
    if (typeof this.giftThresholdText === 'string' && this.giftThresholdText !== tekst) {
      this.giftIntroText = this.giftIntroText.split(this.giftThresholdText).join(tekst);
      if (this.giftIntro && this.state.gifts.length) this.giftIntro.textContent = this.giftIntroText;
    }
    this.giftThresholdText = tekst;
  };

  Widget.prototype.hasGiftStep = function () {
    return this.state.giftStepEnabled === true;
  };

  /* Поръчката вече е създадена без подаръка. Пазим и адреса ѝ, и точното тяло,
     с което е създадена: следващият натиск пренасочва само ако междувременно
     нищо не се е променило. Иначе тръгва нова заявка — по-добре втори draft,
     отколкото плащане по остарели данни. */
  Widget.prototype.showGiftGone = function (invoiceUrl) {
    this.state.giftVariantId = null;
    if (this.giftsBox) {
      var radios = this.giftsBox.querySelectorAll('input[name="f2gift"]');
      Array.prototype.forEach.call(radios, function (radio) { radio.checked = false; });
    }
    this.state.readyInvoiceUrl = invoiceUrl;
    this.state.readyBody = JSON.stringify(this.buildRequest());
    this.setSubmitting(false);
    this.updateReview();
    if (this.giftGoneEl) {
      /* Отказите вече са ДВА: изчерпано заглавие и количка под прага. Текстът
         не твърди кой от тях е бил – сървърът не връща причина, а уверено
         грешното обяснение е по-лошо от липсващото. */
      this.giftGoneEl.textContent = 'Подаръкът отпадна от тази поръчка. '
        + 'Поръчката е запазена и продължава без него. Натисни пак „Продължи към плащане“.';
      this.giftGoneEl.hidden = false;
      if (this.giftGoneEl.scrollIntoView) this.giftGoneEl.scrollIntoView({ block: 'nearest' });
    }
  };

  Widget.prototype.hideGiftGone = function () {
    if (this.giftGoneEl) { this.giftGoneEl.textContent = ''; this.giftGoneEl.hidden = true; }
  };

  Widget.prototype.currentStepKey = function () {
    return L.stepKey(this.state.step, this.hasGiftStep());
  };

  /* ---- Методи на доставка ---- */

  Widget.prototype.renderMethods = function () {
    var self = this;
    var methods = (this.cfg.methods || []).slice().sort(function (a, b) {
      return (a.displayOrder || 0) - (b.displayOrder || 0);
    });
    this.methodsBox.innerHTML = '';
    methods.forEach(function (m, i) {
      var key = m.courier + ':' + m.service;
      var id = 'marmot-f2-m-' + i;
      var wrap = document.createElement('label');
      wrap.className = 'marmot-f2__method';
      wrap.setAttribute('for', id);
      // §4.2: без обещание за срок в v1 — само име + цена. Пояснение има само
      // BOX NOW; без него разметката на реда е заварената.
      var hint = L.methodHint ? L.methodHint(key) : null;
      wrap.innerHTML =
        '<input class="marmot-f2__method-radio" type="radio" name="f2method" id="' + id + '" value="' + key + '">' +
        '<span class="marmot-f2__method-name">' + (METHOD_LABELS[key] || key) +
        (hint ? '<span class="marmot-f2__method-hint">' + escapeHtml(hint) + '</span>' : '') + '</span>' +
        '<span class="marmot-f2__method-price" data-price-eur="' + (m.priceEur || 0) + '">' + methodPriceHtml(m.priceEur || 0, false) + '</span>';
      var input = wrap.querySelector('input');
      input.addEventListener('change', function () { self.onMethodChange(m); });
      self.methodsBox.appendChild(wrap);
    });
  };

  // При достигнат праг за безплатна доставка цената на всеки метод се зачертава
  // с „безплатно" до нея — еднозначно, без противоречие с фиша/количката.
  Widget.prototype.updateMethodPrices = function (isFree) {
    if (!this.methodsBox) return;
    var els = this.methodsBox.querySelectorAll('.marmot-f2__method-price');
    Array.prototype.forEach.call(els, function (el) {
      var eur = parseFloat(el.getAttribute('data-price-eur')) || 0;
      el.innerHTML = methodPriceHtml(eur, isFree);
    });
  };

  // Цената на метода като HTML. Метод с цена 0 (промо) е „безплатно“ и под
  // прага; над 0 изгледът е заварения – зачертана цена + „безплатно“ при праг,
  // иначе само цената. Без L.methodPriceView (стар логически файл от кеша) –
  // заварения изглед.
  function methodPriceHtml(eur, isFree) {
    var v = L.methodPriceView ? L.methodPriceView(eur, isFree)
      : (isFree ? { old: L.money(Math.round(eur * 100)), free: true } : { old: null, free: false, text: L.money(Math.round(eur * 100)) });
    if (!v.free) return escapeHtml(v.text);
    return (v.old ? '<s class="marmot-f2__method-price-old">' + escapeHtml(v.old) + '</s> ' : '') +
      '<span class="marmot-f2__method-price-free">безплатно</span>';
  }

  Widget.prototype.onMethodChange = function (m) {
    this.clearError('method');
    // §4.1 — смяна на метод: нулира офиса и обезсилва започнатия draft опит.
    var next = L.applyMethodChange(this.state, m);
    this.state.courier = next.courier;
    this.state.service = next.service;
    this.state.officeId = next.officeId;
    this.state.officeLabel = next.officeLabel;
    this.state.officeType = next.officeType;
    this.state.idempotencyKey = next.idempotencyKey;
    this.state.discount = next.discount;
    if (next.discountReset) {
      // Смяна между два реални метода: кешът пада заедно с числото.
      this.state.discountCache = null;
      this.promoCheckSeq++;
      this.showNeutralPromoNote();
    }
    if (next.officeReset) { this.clearOfficeUI(); this.clearAddressUI(); }
    this.applyOfficeTexts();

    if (next.needsOffice) { show(this.officeBox); hide(this.addressBox); }
    else if (next.needsAddress) { hide(this.officeBox); show(this.addressBox); }
    else { hide(this.officeBox); hide(this.addressBox); }

    this.updateSummary();
    this.updateStepUI();
    // Пуска се ВИНАГИ, щом има код. Дедупликацията е работа на кеша, не на
    // този флаг: при годен кеш applyPromo излиза без заявка. Иначе провален
    // опит на стъпка 1 (мрежа, хълцане на Shopify) оставаше без втори шанс до
    // края на сесията, защото първият избор на метод не е „нулиране".
    if (this.state.promo) this.applyPromo();
  };

  // Етикет и подсказка на полето за офис по куриера. Текстовете от снипета се
  // запомнят при първото извикване и се връщат за Спиди/Еконт без промяна.
  Widget.prototype.applyOfficeTexts = function () {
    if (!this.officeInput) return;
    var label = this.root.querySelector('label[for="marmot-f2-office-q"]');
    if (!this.officeTextDefaults) {
      this.officeTextDefaults = {
        label: label ? label.textContent : '',
        placeholder: this.officeInput.getAttribute('placeholder') || ''
      };
    }
    var texts = (L.officeTexts && L.officeTexts(this.state.courier)) || this.officeTextDefaults;
    if (label) label.textContent = texts.label;
    this.officeInput.setAttribute('placeholder', texts.placeholder);
  };

  // Нулира UI-то на града и офиса (officeId/label/type ги нулира логическият модул).
  Widget.prototype.clearOfficeUI = function () {
    this.state.cityName = null;
    this.state.cityZip = null;
    this.cityOffices = [];
    if (this.cityInput) this.cityInput.value = '';
    if (this.officeInput) this.officeInput.value = '';
    if (this.officeField) this.officeField.hidden = true;
    this.hideAllLists();
    this.clearError('officeCity');
    this.clearError('office');
  };

  Widget.prototype.showList = function (listEl, inputEl) {
    if (listEl) listEl.hidden = false;
    if (inputEl) inputEl.setAttribute('aria-expanded', 'true');
    // Скролът се задейства ТУК, при отварянето, а не само при фокус: списъкът
    // идва след debounce-а на упита, така че по време на focusin още няма какво
    // да се скролва (телефонен тест 26.07).
    this.fitList(listEl, inputEl);
  };
  Widget.prototype.hideList = function (listEl, inputEl) {
    if (listEl) {
      listEl.hidden = true;
      listEl.style.maxHeight = '';
      listEl.classList.remove('marmot-f2__office-list--up');
    }
    if (inputEl) inputEl.setAttribute('aria-expanded', 'false');
  };

  /* Списъкът е inline (в потока), а футърът е лепнат отдолу — значи може да
     остане ПОД него. При отваряне: 1) вдигаме полето към върха на модала, за да
     има място отдолу; 2) режем височината до свободното между списъка и футъра;
     3) ако отдолу пак не стига, а отгоре има повече — отваряме нагоре. */
  var LIST_MIN_H = 140;
  var LIST_MAX_H = 320;

  Widget.prototype.fitList = function (listEl, inputEl) {
    var dlg = this.dialog;
    if (!listEl || listEl.hidden || !dlg || !inputEl) return;
    var self = this;
    var apply = function () {
      var footH = self.foot ? self.foot.offsetHeight : 0;
      var gap = 8;
      listEl.classList.remove('marmot-f2__office-list--up');
      listEl.style.maxHeight = '';

      // 1) полето колкото може по-нагоре в скролващия контейнер на модала
      var dlgTop = dlg.getBoundingClientRect().top;
      var lift = inputEl.getBoundingClientRect().top - (dlgTop + 12);
      if (lift > 1) dlg.scrollTop += lift; // браузърът клампва, ако няма накъде

      // 2) свободното място между списъка и лепнатия футър
      var dlgRect = dlg.getBoundingClientRect();
      var inputRect = inputEl.getBoundingClientRect();
      var listTop = listEl.getBoundingClientRect().top;
      var below = Math.round(dlgRect.bottom - footH - gap - listTop);
      if (below >= LIST_MIN_H) {
        listEl.style.maxHeight = Math.min(below, LIST_MAX_H) + 'px';
        return;
      }
      // 3) отдолу не стига — отваряме нагоре, ако там има повече място
      var above = Math.round(inputRect.top - dlgRect.top - gap);
      if (above > below) {
        listEl.classList.add('marmot-f2__office-list--up');
        listEl.style.maxHeight = Math.min(above, LIST_MAX_H) + 'px';
      } else {
        listEl.style.maxHeight = Math.max(below, 96) + 'px';
      }
    };
    apply();
    // На мобилен клавиатурата/адресната лента местят viewport-а след отварянето
    // — мерим втори път на следващия кадър.
    if (window.requestAnimationFrame) window.requestAnimationFrame(apply);
    else setTimeout(apply, 16);
  };
  Widget.prototype.hideAllLists = function () {
    this.hideList(this.cityList, this.cityInput);
    this.hideList(this.officeList, this.officeInput);
    this.hideList(this.addrCityList, this.addrCityInput);
    this.hideList(this.addrStreetList, this.addrStreetInput);
  };

  /* ---- Стъпкова навигация ---- */

  Widget.prototype.methodSelected = function () {
    return !!(this.state.courier && this.state.service);
  };

  Widget.prototype.goToStep = function (n) {
    n = Math.max(1, Math.min(L.totalSteps(this.hasGiftStep()), n));
    this.state.step = n;
    this.hideAllLists();
    this.clearAllErrors();
    this.hideGiftGone();
    this.updateStepUI();
    // Фокус върху първото поле на стъпката, скрол до върха.
    var active = this.root.querySelector('[data-f2-step="' + this.currentStepKey() + '"]');
    if (this.dialog) this.dialog.scrollTop = 0;
    if (active) {
      var first = active.querySelector('input:not([type="hidden"]), button, select, textarea');
      if (first) { try { first.focus(); } catch (e) {} }
    }
  };

  // Напред само с бутона; последната стъпка предава към реалния чекаут.
  Widget.prototype.advance = function () {
    var step = this.state.step;
    var hasGift = this.hasGiftStep();
    if (step < L.totalSteps(hasGift)) {
      // Винаги валидираме и показваме грешки — CTA-то не е тихо мъртво на
      // доставката без метод, независимо кой видим номер има тази стъпка.
      var errors = this.validateStep(step);
      if (this.showErrors(errors)) return;
      this.goToStep(L.nextStep(step, hasGift));
    } else {
      this.submit();
    }
  };

  Widget.prototype.back = function () {
    if (this.state.step > 1) this.goToStep(this.state.step - 1);
  };

  // Рейлът позволява само връщане назад (не скок напред).
  Widget.prototype.railGoto = function (n) {
    this.goToStep(L.railTarget(this.state.step, n, this.hasGiftStep()));
  };

  Widget.prototype.updateStepUI = function () {
    var step = this.state.step;
    var hasGift = this.hasGiftStep();
    var flags = L.stepFlags(step, hasGift);
    var key = flags.currentKey;

    var sections = this.root.querySelectorAll('[data-f2-step]');
    Array.prototype.forEach.call(sections, function (sec) {
      sec.hidden = sec.getAttribute('data-f2-step') !== key;
    });

    // Свити обобщения на предишните стъпки.
    this.updateRecap('details', flags.detailsDone, this.contactRecap(), L.stepNumber('details', hasGift), 'Данни');
    this.updateRecap('delivery', flags.deliveryDone, this.deliveryRecap(), L.stepNumber('delivery', hasGift), 'Доставка');

    // Рейл: маркиране на завършени/активна + забрана за скок напред.
    if (this.rail) {
      var items = this.rail.querySelectorAll('[data-f2-rail-key]');
      Array.prototype.forEach.call(items, function (li) {
        var railKey = li.getAttribute('data-f2-rail-key');
        var n = L.stepNumber(railKey, hasGift);
        li.hidden = n === null;
        if (n === null) return;
        li.setAttribute('data-f2-rail-step', String(n));
        li.classList.toggle('is-active', n === step);
        li.classList.toggle('is-done', n < step);
        li.classList.toggle('is-upcoming', n > step);
        var btn = li.querySelector('[data-f2-goto]');
        if (btn) {
          btn.setAttribute('data-f2-goto', String(n));
          btn.disabled = n > step; // напред през рейла не може
        }
        var num = li.querySelector('.marmot-f2__rail-num');
        if (num) num.textContent = String(n);
      });
    }

    if (this.backBtn) this.backBtn.hidden = !flags.canBack;
    if (this.stepOf) this.stepOf.textContent = 'Стъпка ' + step + ' от ' + flags.total;
    if (this.titleEl) this.titleEl.textContent = STEP_TITLES[key] || STEP_TITLES.details;

    // CTA: етикет + визуален намек „още не си готов". Бутонът НЕ е реално
    // disabled — кликът пак валидира и показва защо (напр. „Избери метод"),
    // затова без aria-disabled (би било в разрез с това, че е активен).
    var enabled = L.canAdvance(step, this.methodSelected(), hasGift);
    if (this.ctaLabel) this.ctaLabel.textContent = L.ctaLabel(step, this.methodSelected(), hasGift);
    if (this.cta) this.cta.classList.toggle('is-disabled', !enabled);

    if (key === 'review') this.updateReview();
  };

  Widget.prototype.updateRecap = function (key, visible, valueText, stepNumber, label) {
    var recap = this.root.querySelector('[data-f2-recap="' + key + '"]');
    if (!recap) return;
    recap.hidden = !visible;
    recap.setAttribute('data-f2-goto', String(stepNumber));
    var recapLabel = recap.querySelector('[data-f2-recap-label]');
    if (recapLabel) recapLabel.textContent = stepNumber + ' · ' + label;
    var val = recap.querySelector('[data-f2-recap-value="' + key + '"]');
    if (val) val.textContent = valueText || '';
  };

  Widget.prototype.contactRecap = function () {
    var name = [this.val('firstName'), this.val('lastName')].filter(Boolean).join(' ');
    var parts = [name, this.val('email'), this.val('phone')].filter(Boolean);
    return parts.join(' · ');
  };

  Widget.prototype.deliveryRecap = function () {
    if (!this.methodSelected()) return '';
    var label = METHOD_LABELS[this.state.courier + ':' + this.state.service] || '';
    var detail = '';
    if (this.state.service === 'office') detail = this.state.officeLabel || '';
    else if (this.state.service === 'address') {
      if (this.state.addrFallback) {
        detail = [this.val('fb_city'), this.val('fb_address1')].filter(Boolean).join(', ');
      } else {
        var recapAddr = L.addrRecap(this.state.addrPick, this.addrVals());
        detail = [this.state.addrSiteName, recapAddr].filter(Boolean).join(', ');
      }
    }
    return detail ? label + ' – ' + detail : label;
  };

  /* ---- Прихващане на стандартния checkout ---- */

  Widget.prototype.bindCheckoutInterception = function () {
    var self = this;
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('button[name="checkout"]') : null;
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      if (self.isCartPageNode(btn)) self.openPopup();
      else window.location.href = L.cartHref ? L.cartHref(window.location.search) : '/cart';
    }, true);

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form && form.id === 'cart') {
        e.preventDefault();
        e.stopPropagation();
        self.openPopup();
      }
    }, true);
  };

  Widget.prototype.isCartPageNode = function (node) {
    return !!(node.closest('cart-items') || node.closest('#main-cart-items') ||
      node.closest('#cart') || node.closest('.cart-page-column'));
  };

  /* ---- Отваряне/затваряне ---- */

  Widget.prototype.bindPopupControls = function () {
    var self = this;
    this.overlay.addEventListener('click', function () { self.closePopup(); });
    var closeBtn = this.root.querySelector('[data-f2-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { self.closePopup(); });
    document.addEventListener('keydown', function (e) {
      if (!self.state.open) return;
      if (e.key === 'Escape') { e.preventDefault(); self.closePopup(); return; }
      if (e.key === 'Tab') self.trapFocus(e);
    });

    if (this.backBtn) this.backBtn.addEventListener('click', function () { self.back(); });
    if (this.skipGift) {
      this.skipGift.addEventListener('click', function () {
        self.state.giftVariantId = null;
        var radios = self.giftsBox ? self.giftsBox.querySelectorAll('input[name="f2gift"]') : [];
        Array.prototype.forEach.call(radios, function (radio) { radio.checked = false; });
        self.goToStep(L.nextStep(self.state.step, self.hasGiftStep()));
      });
    }

    // Клавиатура/лента на браузъра сменят видимата височина И offsetTop →
    // пресинхронизирай и при resize, и при scroll на visual viewport-а.
    if (window.visualViewport) {
      var onViewport = function () { if (self.state.open) self.syncViewportHeight(); };
      window.visualViewport.addEventListener('resize', onViewport);
      window.visualViewport.addEventListener('scroll', onViewport);
    }

    // Рейл + свити обобщения → връщане към стъпка.
    this.root.addEventListener('click', function (e) {
      var goBtn = e.target && e.target.closest ? e.target.closest('[data-f2-goto]') : null;
      if (goBtn && self.root.contains(goBtn)) {
        var n = parseInt(goBtn.getAttribute('data-f2-goto'), 10);
        if (n) { e.preventDefault(); self.railGoto(n); }
      }
    });
  };

  Widget.prototype.openPopup = function () {
    if (this.state.open) return;
    // Само вече пристигнал непразен списък може да промени броя на стъпките.
    this.state.giftStepEnabled = this.cfg.giftEnabled === true &&
      this.state.gifts.length > 0 &&
      L.giftMeetsThreshold(this.giftBaseCents(), this.cfg.giftThresholdEur);
    if (!this.state.giftStepEnabled) this.state.giftVariantId = null;
    // Пресвеждане за ТОВА отваряне, ако успее да се върне навреме, и за всяко
    // следващо. Броят на стъпките остава замразен от реда по-горе.
    this.loadGifts();
    this.state.open = true;
    this.state.metaCheckoutOpenSeq++;
    this.state.lastFocus = document.activeElement;
    this.root.hidden = false;
    this.overlay.hidden = false;
    this.dialog.hidden = false;
    document.documentElement.classList.add('marmot-f2-open');
    this.syncViewportHeight();
    this.goToStep(1);
    this.loadCart(this.state.metaCheckoutOpenSeq);
  };

  // Мобилно: свива диалога до видимата височина (visualViewport), за да остане
  // лепнатият футър и основният бутон над клавиатурата/лентата на браузъра.
  Widget.prototype.syncViewportHeight = function () {
    if (!this.dialog) return;
    var vv = window.visualViewport;
    if (vv && window.innerWidth < 768) {
      // Свиваме диалога до видимата височина И го местим с offsetTop-а на visual
      // viewport-а. На iOS клавиатурата не свива layout viewport-а, а мести
      // visible областта → без translateY лепнатият футър остава ПОД клавиатурата.
      this.dialog.style.height = Math.round(vv.height) + 'px';
      this.dialog.style.transform = 'translateY(' + Math.round(vv.offsetTop) + 'px)';
    } else {
      this.dialog.style.height = '';
      this.dialog.style.transform = '';
    }
  };

  Widget.prototype.closePopup = function () {
    if (!this.state.open) return;
    this.state.open = false;
    this.overlay.hidden = true;
    this.dialog.hidden = true;
    this.root.hidden = true;
    document.documentElement.classList.remove('marmot-f2-open');
    if (this.dialog) { this.dialog.style.height = ''; this.dialog.style.transform = ''; }
    this.hideAllLists();
    if (this.state.lastFocus && this.state.lastFocus.focus) this.state.lastFocus.focus();
  };

  Widget.prototype.trapFocus = function (e) {
    var focusables = this.dialog.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    var visible = Array.prototype.filter.call(focusables, function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
    if (!visible.length) return;
    var first = visible[0];
    var last = visible[visible.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  /* ---- Количка + обобщение ---- */

  /* Връща обещание, което се изпълнява след опита (успешен или не). Така
     „Потвърждение" и бутонът за плащане могат да изчакат повторно зареждане,
     вместо да тръгнат с празна количка. */
  Widget.prototype.loadCart = function (metaCheckoutOpenSeq) {
    var self = this;
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Без `methodSelected()`: проверката тръгва и на стъпка 1. Иначе код,
        // въведен преди /cart.js да е върнал, оставаше на бележката чак до
        // избора на доставка — точно сценарият, който задачата маха.
        var shouldCheckSavedPromo = !self.state.cart && !self.state.promoWasChecked &&
          !!self.state.promo;
        var firstCartAfterPromo = !self.state.cart && (self.state.discount || self.state.promoChecking);
        var cartBasisChanged = firstCartAfterPromo || L.cartChanged(self.state.cart, cart);
        var promoAffected = self.state.promoWasChecked || self.state.discount || self.state.promoChecking || self.state.promo;
        if (cartBasisChanged && promoAffected) {
          self.state.discount = null;
          self.state.discountCache = null;
          if (self.state.promoWasChecked) self.state.idempotencyKey = null;
          self.promoCheckSeq++;
          self.showNeutralPromoNote();
        }
        self.state.cart = cart;
        self.updateSummary();
        // Смени ли се количката, числото е нулирано по-горе — пуска се наново,
        // вместо да остане бележката. Без метод също, по същата причина.
        if (shouldCheckSavedPromo || (cartBasisChanged && promoAffected && self.state.promo)) {
          self.applyPromo();
        }
        self.publishMetaCheckoutStarted(cart, metaCheckoutOpenSeq);
        self.publishOpenAiCheckoutStarted(cart, metaCheckoutOpenSeq);
        self.syncOpenAiOppref();
      })
      .catch(function () { /* обобщението остава с тирета */ });
  };

  /* OpenAI Ads: checkout_started от същото място като Meta, веднъж на отваряне.
     Пикселът (marmot-openai-ads.js) сам решава дали има съгласие; тук само
     се пази „веднъж", за да не се прати късно при по-късно съгласие. */
  Widget.prototype.publishOpenAiCheckoutStarted = function (cart, metaCheckoutOpenSeq) {
    try {
      var ads = window.MarmotOpenAiAds;
      if (!ads || typeof ads.checkoutStarted !== 'function') return;
      if (!L.shouldPublishOpenAiCheckout(this.state, metaCheckoutOpenSeq)) return;
      if (ads.checkoutStarted(cart)) this.state.oaiCheckoutPublishedSeq = metaCheckoutOpenSeq;
    } catch (e) { /* пикселът не бива да прекъсва checkout потока */ }
  };

  /* OpenAI Ads: _oppref (кликът от ChatGPT) влиза в количката като атрибут,
     за да стигне до Draft Order-а през attributes; без съгласие/бисквитка се
     маха. Резултатът се отразява върху state.cart, за да тръгне с buildRequest. */
  Widget.prototype.syncOpenAiOppref = function () {
    var self = this;
    try {
      var ads = window.MarmotOpenAiAds;
      if (!ads || typeof ads.syncCartOppref !== 'function' || !self.state.cart) return;
      ads.syncCartOppref(self.state.cart).then(function (written) {
        if (written && self.state.cart) L.applyCartOppref(self.state.cart, written.value, written.attributes);
      }).catch(function () { /* без атрибут – поръчката пак минава */ });
    } catch (e) { /* пикселът не бива да прекъсва checkout потока */ }
  };

  Widget.prototype.publishMetaCheckoutStarted = function (cart, metaCheckoutOpenSeq) {
    try {
      if (!L.shouldPublishMetaCheckout(this.state, metaCheckoutOpenSeq)) return;
      var payload = L.metaInitiateCheckoutPayload(cart, uuid());
      if (!payload) return;
      if (!window.Shopify || !window.Shopify.analytics ||
          typeof window.Shopify.analytics.publish !== 'function') return;
      var publication = window.Shopify.analytics.publish('marmot_checkout_started', payload);
      if (publication && typeof publication.catch === 'function') {
        publication.catch(function () { /* тих отказ от analytics sandbox-a */ });
      }
      this.state.metaCheckoutPublishedSeq = metaCheckoutOpenSeq;
    } catch (e) { /* analytics не бива да прекъсва checkout потока */ }
  };

  Widget.prototype.cartSubtotalCents = function () {
    var cart = this.state.cart;
    if (!cart || !cart.items) return null;
    return cart.items.reduce(function (sum, it) { return sum + (it.final_line_price || 0); }, 0);
  };

  Widget.prototype.cartItemCount = function () {
    var cart = this.state.cart;
    if (!cart || !cart.items) return 0;
    return cart.items.reduce(function (n, it) { return n + (it.quantity || 0); }, 0);
  };

  Widget.prototype.selectedMethodPriceEur = function () {
    if (!this.methodSelected()) return null;
    var key = this.state.courier + ':' + this.state.service;
    var m = (this.cfg.methods || []).filter(function (x) { return (x.courier + ':' + x.service) === key; })[0];
    return m ? (m.priceEur || 0) : null;
  };

  Widget.prototype.renderCartLines = function () {
    var box = this.linesBox;
    if (!box) return;
    box.innerHTML = '';
    var cart = this.state.cart;
    if (!cart || !cart.items) return;
    cart.items.forEach(function (it) {
      var row = document.createElement('div');
      row.className = 'marmot-f2__line';
      var name = document.createElement('span');
      name.className = 'marmot-f2__line-name';
      name.textContent = (it.product_title || it.title) + (it.quantity > 1 ? ' × ' + it.quantity : '');
      var price = document.createElement('span');
      price.className = 'marmot-f2__line-price';
      price.textContent = L.money(it.final_line_price);
      row.appendChild(name);
      row.appendChild(price);
      box.appendChild(row);
    });
  };

  Widget.prototype.updateSummary = function () {
    this.renderCartLines();
    this.applyItemsOpen();

    var subtotal = this.cartSubtotalCents();
    var priceEur = this.selectedMethodPriceEur();
    var totals = L.computeTotals({ subtotalCents: subtotal, methodPriceEur: priceEur, cfg: this.cfg, discount: this.state.discount });
    var discount = L.discountView(this.state.discount, subtotal, totals.shippingCents);
    var hasCartDiscountCodes = !!readCartDiscountCodes(this.state.cart);

    // При достигнат праг всички методи стават безплатни — отрази го на картите.
    this.updateMethodPrices(subtotal != null && L.isFreeShipping(subtotal, this.cfg));

    setText(this.root, '[data-f2-subtotal]', subtotal == null ? '—' : L.money(subtotal));
    var discountLabel = this.root.querySelector('[data-f2-discount-label]');
    var discountValue = this.root.querySelector('[data-f2-discount]');
    if (discountLabel) discountLabel.hidden = !discount.show;
    if (discountValue) discountValue.hidden = !discount.show;
    if (discount.show) {
      setText(this.root, '[data-f2-discount-label]', L.discountLabel(discount.code, hasCartDiscountCodes));
      setText(this.root, '[data-f2-discount]', '−' + L.money(discount.discountCents));
    }
    setText(this.root, '[data-f2-shipping]', L.shippingText ? L.shippingText(totals) : (totals.shippingCents == null ? '—' : (totals.isFree ? 'Безплатно' : L.money(totals.shippingCents))));
    setText(this.root, '[data-f2-total]', totals.totalCents == null ? '—' : L.money(totals.totalCents));

    // Брояч на артикулите в toggle-а.
    var count = this.cartItemCount();
    var countTxt = count ? count + ' ' + plural(count, 'артикул', 'артикула', 'артикула') + (subtotal != null ? ' · ' + L.money(subtotal, false) : '') : 'Артикули';
    setText(this.root, '[data-f2-items-count]', countTxt);

    // Прогрес до безплатна доставка (видим от стъпка 1).
    var prog = L.freeShipProgress(subtotal, this.cfg);
    var free = this.root.querySelector('[data-f2-freeship]');
    if (free) {
      free.hidden = !prog.show;
      if (prog.show) {
        // Решението от 09.08.2026 казва, че „(преди отстъпки)" стои там, където
        // се обявява самото правило с числото — PDP, страницата на комплект и
        // marquee лентата. В ТОЗИ екран обаче правилото не се обявява никъде,
        // тоест уточнението няма къде другаде да се хване, а прагът тук е
        // единственото място, където клиентът вижда число за доставката СЛЕД
        // като е въвел код. Затова редът го носи.
        setText(this.root, '[data-f2-freeship-text]', 'Още ' + L.money(prog.remainingCents, false) + ' до безплатна доставка (преди отстъпки)');
        var fill = this.root.querySelector('[data-f2-freeship-fill]');
        if (fill) fill.style.width = prog.percent + '%';
      }
    }

    if (this.currentStepKey() === 'review') this.updateReview();
  };

  /* Количката не е дошла при отварянето (мрежата на телефона, прекъсната
     заявка). Веднъж на опит пробваме пак, иначе сумите остават „—" до края. */
  Widget.prototype.reloadMissingCart = function () {
    if (this.state.cart || this.state.cartReloading) return null;
    var self = this;
    this.state.cartReloading = true;
    return this.loadCart(this.state.metaCheckoutOpenSeq).then(function () {
      self.state.cartReloading = false;
    });
  };

  Widget.prototype.updateReview = function () {
    if (!this.state.cart) this.reloadMissingCart();
    var subtotal = this.cartSubtotalCents();
    var priceEur = this.selectedMethodPriceEur();
    var totals = L.computeTotals({ subtotalCents: subtotal, methodPriceEur: priceEur, cfg: this.cfg, discount: this.state.discount });
    var discount = L.discountView(this.state.discount, subtotal, totals.shippingCents);
    var hasCartDiscountCodes = !!readCartDiscountCodes(this.state.cart);
    var count = this.cartItemCount();
    setText(this.root, '[data-f2-rev-items]', count ? count + ' ' + plural(count, 'книга', 'книги', 'книги') : 'Книги');
    setText(this.root, '[data-f2-rev-sub]', subtotal == null ? '—' : L.money(subtotal));
    setText(this.root, '[data-f2-rev-method]', this.methodSelected() ? (METHOD_LABELS[this.state.courier + ':' + this.state.service] || 'Доставка') : 'Доставка');
    if (L.paymentNoteText) setText(this.root, '[data-f2-payment-note]', L.paymentNoteText(this.methodSelected() ? this.state.courier : null));
    setText(this.root, '[data-f2-rev-ship]', L.shippingText ? L.shippingText(totals) : (totals.shippingCents == null ? '—' : (totals.isFree ? 'Безплатно' : L.money(totals.shippingCents))));
    var discountRow = this.root.querySelector('[data-f2-rev-discount-row]');
    if (discountRow) discountRow.hidden = !discount.show;
    if (discount.show) {
      setText(this.root, '[data-f2-rev-discount-label]', L.discountLabel(discount.code, hasCartDiscountCodes));
      setText(this.root, '[data-f2-rev-discount]', '−' + L.money(discount.discountCents));
    }
    var gift = this.selectedGift();
    var giftRow = this.root.querySelector('[data-f2-rev-gift-row]');
    if (giftRow) giftRow.hidden = !gift;
    if (gift) setText(this.root, '[data-f2-rev-gift]', 'Подарък: ' + gift.title);
    setText(this.root, '[data-f2-rev-total]', totals.totalCents == null ? '—' : L.money(totals.totalCents));
  };

  Widget.prototype.applyItemsOpen = function () {
    if (this.linesBox) this.linesBox.hidden = !this.state.itemsOpen;
    if (this.itemsToggle) this.itemsToggle.setAttribute('aria-expanded', this.state.itemsOpen ? 'true' : 'false');
    setText(this.root, '[data-f2-items-caret]', this.state.itemsOpen ? '▴' : '▾');
  };

  Widget.prototype.showPromoMessage = function (message) {
    if (!this.promoNoteEl) return;
    this.promoNoteEl.hidden = !message;
    this.promoNoteEl.textContent = message || '';
  };

  /* Неутралната бележка: „записан, проверяваме го". Ползва се ПРЕДИ и ПО ВРЕМЕ
     на проверката. Текстът СЛЕД приключила проверка НЕ се избира тук — той идва
     готов от `discountOutcome` като `outcome.message`, защото само тя знае дали
     число няма изобщо („не успяхме да го пресметнем") или още не се връзва с
     видимите редове („проверяваме го" — изборът на метод ще го произведе).
     Два източника за един текст вече веднъж ни счупиха екрана. */
  Widget.prototype.showNeutralPromoNote = function () {
    var note = L.promoNote(this.state.promo);
    this.showPromoMessage(note ? note.text : null);
  };

  Widget.prototype.setPromoChecking = function (on) {
    this.state.promoChecking = on;
    this.updatePromoButton();
  };

  Widget.prototype.updatePromoButton = function () {
    if (this.promoApply) {
      this.promoApply.disabled = this.state.promoChecking || this.state.promoCoolingDown;
      this.promoApply.setAttribute('aria-busy', this.state.promoChecking ? 'true' : 'false');
    }
  };

  Widget.prototype.recordPromoOutcome = function (status) {
    var self = this;
    var next = L.promoFailureState(this.state.promoFailures, status);
    this.state.promoFailures = next.failures;
    if (this.promoCooldownTimer) clearTimeout(this.promoCooldownTimer);
    this.promoCooldownTimer = null;
    this.state.promoCoolingDown = next.waitMs > 0;
    this.updatePromoButton();
    if (next.waitMs > 0) {
      this.promoCooldownTimer = setTimeout(function () {
        self.promoCooldownTimer = null;
        self.state.promoCoolingDown = false;
        self.updatePromoButton();
        // Охлаждането свърши: отказаният заради него опит тръгва сега.
        self.runPendingPromoRecheck();
      }, next.waitMs);
    }
  };

  Widget.prototype.applyPromo = function () {
    var self = this;
    if (!this.promoInput) return;
    var note = L.promoNote(this.promoInput.value);
    if (!note) {
      this.state.promo = '';
      this.state.discount = null;
      this.promoCheckSeq++;
      this.showPromoMessage(null);
      this.updateSummary();
      return;
    }

    // Преди зареждането на количката кодът се пази, но не напуска браузъра.
    // Липсващият метод вече НЕ спира проверката — стъпка 1 също пита сървъра.
    // loadCart и onMethodChange пускат проверката автоматично.
    if (!L.shouldRequestDiscount(!!this.state.cart, note.code)) {
      this.state.promo = note.code;
      this.state.discount = null;
      this.promoCheckSeq++;
      this.showNeutralPromoNote();
      this.updateSummary();
      return;
    }

    var fingerprint = L.cartSignature(this.state.cart);
    var plan = L.promoRequestPlan({
      cache: this.state.discountCache,
      code: note.code,
      fingerprint: fingerprint,
      inFlight: this.state.promoChecking,
      coolingDown: this.state.promoCoolingDown,
      sequence: this.promoCheckSeq
    });

    if (plan.action === 'reuse') {
      // Преизползване: вдигаме брояча изрично, за да обезсилим всеки отговор в
      // полет, вместо да разчитаме на страничен ефект от друг слушател.
      this.promoCheckSeq++;
      this.state.promo = plan.outcome.code || note.code;
      this.state.discount = plan.outcome.discount;
      this.state.promoWasChecked = true;
      this.state.promoFailures = 0;
      this.showPromoMessage(null);
      this.updateSummary();
      return;
    }
    if (plan.action === 'blocked') {
      // Запомняме намерението — изпълнява се в runPendingPromoRecheck.
      this.promoRecheckPending = true;
      // Охлаждането е единствената блокировка, която клиентът може да усети
      // като „натиснах и нищо не стана": бутонът е заключен, но Enter стига
      // дотук. Заявката ще тръгне сама след таймера — казваме защо се чака.
      if (this.state.promoCoolingDown) this.showPromoMessage(ERROR_MESSAGES.RATE_LIMITED);
      return;
    }

    var gate = plan.gate;
    // Гейтът връща СЛЕДВАЩАТА стойност на брояча — тя става наша чак когато я
    // запишем тук. Без този ред `requestSeq` е вечно с единица пред
    // `self.promoCheckSeq` и `shouldApplyDiscountOutcome` изхвърля ВСЕКИ успешен
    // отговор като застоял: сървърът връща вярното число, а екранът мълчи.
    // Точно този ред изчезна в b8f68e8, когато гейтът беше изнесен в
    // `promoRequestPlan`, и счупи и двете стъпки. `requestSeq` нарочно се чете
    // ОТ брояча, а не от `gate`, за да няма втори източник, който да се разминава.
    this.promoCheckSeq = gate.sequence;
    var requestSeq = this.promoCheckSeq;
    var requestCode = note.code;
    this.state.promo = requestCode;
    this.state.discount = null;
    this.showNeutralPromoNote();
    this.updateSummary();
    this.setPromoChecking(true);
    this.state.promoWasChecked = true;

    var subtotal = this.cartSubtotalCents();
    var baseTotals = L.computeTotals({
      subtotalCents: subtotal,
      methodPriceEur: this.selectedMethodPriceEur(),
      cfg: this.cfg,
      discount: null
    });
    var pricing = { subtotalCents: subtotal, shippingCents: baseTotals.shippingCents };

    L.checkDiscount(requestCode, function () {
      return apiPost(self.apiBase + '/api/shopify/checkout/discount', self.buildRequest(), {
        'X-F2-Session': getF2SessionId()
      });
    }, pricing).then(function (outcome) {
      self.setPromoChecking(false);
      var current = L.promoNote(self.promoInput.value);
      var currentCode = current ? current.code : '';
      if (!L.shouldApplyDiscountOutcome(requestSeq, self.promoCheckSeq, requestCode, currentCode, outcome.status)) {
        // Отговорът е застоял, защото основата се смени, докато го чакахме.
        // Изхвърля се правилно — но ако през това време е бил отказан нов опит
        // заради ТАЗИ заявка, той трябва да тръгне сега. Без този ред
        // отстъпката изчезва тихо и нищо повече не я връща.
        self.runPendingPromoRecheck();
        return;
      }

      if (outcome.status === 'applied') {
        self.state.promo = outcome.code;
        self.state.discount = outcome.discount;
        self.state.discountCache = {
          key: L.discountCacheKey(requestCode, L.cartSignature(self.state.cart)),
          outcome: outcome
        };
        self.showPromoMessage(null);
      } else if (outcome.status === 'rejected') {
        // Отказът се прилага и при разминат брояч (виж `shouldApplyDiscountOutcome`),
        // тоест може да е изчислен срещу СТАРАТА основа. Тогава кодът още не е
        // питан срещу новата и трябва да бъде — иначе обявяваме „не е валиден за
        // тази количка" за количка, срещу която не сме го проверявали.
        if (requestSeq !== self.promoCheckSeq) self.promoRecheckPending = true;
        self.state.promo = '';
        self.state.discount = null;
        self.showPromoMessage(ERROR_MESSAGES.PROMO_REJECTED);
      } else {
        self.state.promo = outcome.code;
        self.state.discount = null;
        // Текстът идва ГОТОВ от `discountOutcome`, не се избира втори път тук:
        // непроверим отговор дава „не успяхме да го пресметнем", а валиден
        // отговор, който още не се връзва с видимите редове, нарочно оставя
        // „проверяваме го" — там изборът на метод ще произведе числото и
        // „не успяхме" би било лъжа в обратната посока.
        self.showPromoMessage(outcome.message || (L.promoNote(outcome.code) || {}).text || null);
      }
      self.recordPromoOutcome(outcome.status);
      self.updateSummary();
      self.runPendingPromoRecheck();
    });
  };

  /* „Отказана заявка" не е „ненужна заявка".

     `promoRequestPlan` връща `blocked`, когато друга заявка е в полет или сме в
     охлаждане. Досега това беше КРАЙНО състояние: смени ли клиентът метода,
     докато тече проверката, броячът се вдигаше, старият отговор пристигаше
     застоял и се изхвърляше правилно — но нищо не пускаше нова заявка. Екранът
     оставаше без ред за отстъпка, с завишено „Общо" и с бележка „проверяваме
     го", която вече не отговаряше на нищо. Тоест точно провалът, който цялата
     задача трябва да предотврати, само през друга врата.

     Затова намерението се ЗАПОМНЯ и се изпълнява веднага щом пътят се освободи:
     след приключила заявка (и по двата изхода — приложен и изхвърлен отговор) и
     след изтичане на охлаждането. Схождането е гарантирано: всяко пускане първо
     нулира флага, а повторен `blocked` пак ще бъде отпушен от същите два входа. */
  Widget.prototype.runPendingPromoRecheck = function () {
    if (!this.promoRecheckPending) return;
    this.promoRecheckPending = false;
    // Условието чете СЪЩИЯ източник, който чете и `applyPromo` — полето, не
    // `state.promo`. Отказаният опит излиза преди `state.promo` да е зададен,
    // тоест по състоянието кодът може да изглежда празен, докато в полето си
    // стои. Пазач по другия източник губеше намерението тихо.
    if (this.promoInput && L.promoNote(this.promoInput.value)) this.applyPromo();
  };

  /* ---- Форма: фактура, промо, търсене на офис ---- */

  Widget.prototype.bindFormBehaviour = function () {
    var self = this;

    var invoiceToggle = this.root.querySelector('[data-f2-invoice-toggle]');
    var invoiceFields = this.root.querySelector('[data-f2-invoice-fields]');
    if (invoiceToggle && invoiceFields) {
      invoiceToggle.addEventListener('change', function () {
        invoiceFields.hidden = !invoiceToggle.checked;
      });
    }

    if (this.itemsToggle) {
      this.itemsToggle.addEventListener('click', function () {
        self.state.itemsOpen = !self.state.itemsOpen;
        self.applyItemsOpen();
      });
    }

    if (this.promoApply && this.promoInput) {
      this.promoApply.addEventListener('click', function () { self.applyPromo(); });
      // Enter в промо полето прилага кода, а не подава формата (не сменя стъпка).
      this.promoInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); self.applyPromo(); }
      });
      // Инвариант: бележката се вижда ТОЧНО когато кодът в полето е приложен и
      // ще пътува към draft-а. Всяка редакция без ново „Приложи" анулира и
      // двете – иначе на клиента остава ред за код, който вече не е в полето,
      // или стар код тръгва към чекаута незабелязано.
      this.promoInput.addEventListener('input', function () {
        var current = L.promoNote(self.promoInput.value);
        var currentCode = current ? current.code : '';
        if (currentCode !== self.state.promo || self.state.discount) {
          self.state.promo = '';
          self.state.discount = null;
          self.promoCheckSeq++;
          self.showPromoMessage(null);
          self.updateSummary();
        }
      });
    }

    if (this.cityInput) {
      this.cityInput.addEventListener('input', function () { self.onCityInput(); });
      this.cityInput.addEventListener('keydown', function (e) { self.onListKeydown(e, self.cityList); });
      this.cityInput.addEventListener('focus', function () {
        if (self.cityList && self.cityList.children.length) self.showList(self.cityList, self.cityInput);
      });
    }
    if (this.officeInput) {
      this.officeInput.addEventListener('input', function () { self.onOfficeInput(); });
      this.officeInput.addEventListener('keydown', function (e) { self.onListKeydown(e, self.officeList); });
      this.officeInput.addEventListener('focus', function () {
        if (self.officeList && self.officeList.children.length) self.showList(self.officeList, self.officeInput);
      });
    }
    // Град за „До личен адрес" (Speedy номенклатура).
    if (this.addrCityInput) {
      this.addrCityInput.addEventListener('input', function () { self.onAddrCityInput(); });
      this.addrCityInput.addEventListener('keydown', function (e) { self.onListKeydown(e, self.addrCityList); });
      this.addrCityInput.addEventListener('focus', function () {
        if (self.addrCityList && self.addrCityList.children.length) self.showList(self.addrCityList, self.addrCityInput);
      });
    }
    // Улица за „До личен адрес".
    if (this.addrStreetInput) {
      this.addrStreetInput.addEventListener('input', function () { self.onAddrStreetInput(); });
      this.addrStreetInput.addEventListener('keydown', function (e) { self.onListKeydown(e, self.addrStreetList); });
      this.addrStreetInput.addEventListener('focus', function () {
        if (self.addrStreetList && self.addrStreetList.children.length) self.showList(self.addrStreetList, self.addrStreetInput);
      });
    }
    // Номер/блок: грешката изчезва, щом човекът започне да пише в полето.
    [['[data-f2-addr-no]', 'addrNo'], ['[data-f2-addr-block]', 'addrBlock']].forEach(function (pair) {
      var el = self.root.querySelector(pair[0]);
      if (el) el.addEventListener('input', function () { self.clearError(pair[1]); });
    });
    // Клик извън полетата с падащи списъци ги затваря.
    document.addEventListener('click', function (e) {
      var inOffice = self.officeBox && self.officeBox.contains(e.target);
      var inAddr = self.addressBox && self.addressBox.contains(e.target);
      if (!inOffice && !inAddr) self.hideAllLists();
    });

    // При фокус скролваме полето във видимото (в скролващия контейнер на модала).
    // Поле с падащ списък (град/улица/офис, role=combobox) → в ГОРНАТА част
    // (block:'start' + scroll-padding-top), за да има място списъкът да се отвори
    // цял под него; и на десктоп. Обикновено поле → център, само на мобилен, за
    // да не остане под клавиатурата/лепнатия футър.
    this.form.addEventListener('focusin', function (e) {
      var target = e.target;
      if (!target || !target.scrollIntoView) return;
      var isCombo = target.getAttribute && target.getAttribute('role') === 'combobox';
      if (isCombo) {
        setTimeout(function () {
          try { target.scrollIntoView({ block: 'start' }); } catch (err) {}
        }, 250);
      } else if (window.innerWidth < 768) {
        setTimeout(function () {
          try { target.scrollIntoView({ block: 'center' }); } catch (err) {}
        }, 300);
      }
    });

    // Единственият вход напред: submit на формата (CTA бутонът или Enter).
    this.form.addEventListener('submit', function (e) { e.preventDefault(); self.advance(); });
  };

  /* Град: пишеш → избираш от списък (град + пощенски код). Смяната на града
     нулира избрания офис и крие офис полето. */
  Widget.prototype.onCityInput = function () {
    var self = this;
    this.clearError('officeCity');
    this.state.cityName = null;
    this.state.cityZip = null;
    this.state.officeId = null;
    this.cityOffices = [];
    this.cityOfficesTruncated = false;
    if (this.officeHint) this.officeHint.hidden = true;
    if (this.officeField) this.officeField.hidden = true;
    if (this.officeInput) this.officeInput.value = '';
    this.hideList(this.officeList, this.officeInput);
    var q = this.cityInput.value.trim();
    clearTimeout(this.officeSearchTimer);
    if (q.replace(/\s/g, '').length < 2) { this.hideList(this.cityList, this.cityInput); return; }
    this.officeSearchTimer = setTimeout(function () { self.searchCities(q); }, 250);
  };

  Widget.prototype.searchCities = function (q) {
    var self = this;
    var courier = this.state.courier;
    if (!courier) return;
    var seq = ++this.officeSearchSeq;
    var url = this.apiBase + '/api/shopify/checkout/offices?courier=' + encodeURIComponent(courier) +
      '&q=' + encodeURIComponent(q) + '&limit=20';
    apiGet(url).then(function (res) {
      if (seq !== self.officeSearchSeq) return; // изпреварен от по-нов упит
      self.renderCities(L.distinctCities((res && res.offices) || [], courier));
    }).catch(function () { self.renderCities([]); });
  };

  Widget.prototype.renderCities = function (cities) {
    var self = this;
    this.cityList.innerHTML = '';
    if (!cities.length) {
      this.cityList.appendChild(emptyLi('Няма намерен град. Провери изписването.'));
      this.showList(this.cityList, this.cityInput);
      return;
    }
    cities.forEach(function (c) {
      var li = document.createElement('li');
      li.className = 'marmot-f2__office-item marmot-f2__office-item--row';
      li.setAttribute('role', 'option');
      li.innerHTML = '<span class="marmot-f2__office-name">' + escapeHtml(c.city) + '</span>' +
        (c.zip ? '<span class="marmot-f2__office-zip">' + escapeHtml(c.zip) + '</span>' : '');
      li.addEventListener('click', function () { self.chooseCity(c); });
      self.cityList.appendChild(li);
    });
    this.showList(this.cityList, this.cityInput);
  };

  Widget.prototype.chooseCity = function (c) {
    clearTimeout(this.officeSearchTimer); // спри чакащ упит да не преотвори списъка след избора
    this.state.cityName = c.city;
    this.state.cityZip = c.zip || null;
    this.state.officeId = null;
    this.cityInput.value = c.city + (c.zip ? ' (' + c.zip + ')' : '');
    this.hideList(this.cityList, this.cityInput);
    this.clearError('officeCity');
    if (this.officeField) this.officeField.hidden = false;
    if (this.officeInput) this.officeInput.value = '';
    this.loadCityOffices(c);
    if (this.officeInput) { try { this.officeInput.focus(); } catch (e) {} }
    this.updateStepUI();
  };

  // Зарежда ВСИЧКИ офиси в избрания град (един упит, филтрира по град+zip).
  // limit=CITY_OFFICE_LIMIT, не 20: София има стотици офиса и автомата и при
  // таван 20 списъкът свършваше по средата на азбуката — изглеждаше като
  // липсваща база (телефонен тест 26.07).
  Widget.prototype.loadCityOffices = function (c) {
    var self = this;
    var courier = this.state.courier;
    if (!courier) return;
    var seq = ++this.officeSearchSeq;
    var url = this.apiBase + '/api/shopify/checkout/offices?courier=' + encodeURIComponent(courier) +
      '&q=' + encodeURIComponent(c.city) + '&limit=' + CITY_OFFICE_LIMIT;
    apiGet(url).then(function (res) {
      if (seq !== self.officeSearchSeq) return;
      var all = (res && res.offices) || [];
      self.cityOffices = all.filter(function (o) {
        return (o.city || '') === c.city && (!c.zip || (o.zip || '') === c.zip);
      });
      // Сървърът казва колко е намерил ПРЕДИ отрязването; ако е орязал, го
      // казваме на човека, вместо да го оставим да мисли, че това са всички.
      var total = typeof (res && res.total) === 'number' ? res.total : all.length;
      self.cityOfficesTruncated = total > all.length;
      self.renderOffices(self.cityOffices);
    }).catch(function () { self.cityOffices = []; self.renderOffices([]); });
  };

  // Офис в града: филтрира client-side из вече заредените офиси.
  Widget.prototype.onOfficeInput = function () {
    this.clearError('office');
    this.state.officeId = null;
    var q = this.officeInput.value.trim().toLowerCase();
    var list = this.cityOffices.filter(function (o) {
      return !q || ((o.name || '') + ' ' + (o.address || '')).toLowerCase().indexOf(q) >= 0;
    });
    this.renderOffices(list);
  };

  // Честен ред под полето: колко офиса има градът и колко виждаш сега.
  Widget.prototype.updateOfficeHint = function (shown) {
    if (!this.officeHint) return;
    var text = L.officeHintText(this.cityOffices.length, shown, this.cityOfficesTruncated, this.state.courier);
    if (!text) { this.officeHint.hidden = true; return; }
    this.officeHint.textContent = text;
    this.officeHint.hidden = false;
  };

  Widget.prototype.renderOffices = function (offices) {
    var self = this;
    this.officeList.innerHTML = '';
    this.updateOfficeHint(offices.length);
    var courier = this.state.courier;
    var texts = L.officeTexts(courier);
    if (!offices.length) {
      this.officeList.appendChild(emptyLi(texts ? texts.empty : 'Няма офис в този град по това търсене.'));
      this.showList(this.officeList, this.officeInput);
      return;
    }
    offices.forEach(function (o) {
      var li = document.createElement('li');
      li.className = 'marmot-f2__office-item';
      li.setAttribute('role', 'option');
      var v = L.officeView(o, courier);
      var typeTag = v.tag ? '<span class="marmot-f2__office-tag">' + escapeHtml(v.tag) + '</span>' : '';
      li.innerHTML =
        '<span class="marmot-f2__office-name">' + escapeHtml(v.name) + typeTag + '</span>' +
        (v.address || !texts ? '<span class="marmot-f2__office-addr">' + escapeHtml(v.address) + '</span>' : '');
      li.addEventListener('click', function () { self.chooseOffice(o); });
      self.officeList.appendChild(li);
    });
    this.showList(this.officeList, this.officeInput);
  };

  Widget.prototype.chooseOffice = function (o) {
    var v = L.officeView(o, this.state.courier);
    this.state.officeId = v.officeId;
    this.state.officeType = v.officeType;
    this.state.officeLabel = v.label;
    this.officeInput.value = v.inputText;
    this.hideList(this.officeList, this.officeInput);
    this.clearError('office');
    this.updateStepUI(); // обнови свитото обобщение на доставката
  };

  /* ---- „До личен адрес" (само Speedy): град + улица от номенклатурата ---- */

  /* Град: пишеш → избираш от списък (град + пощенски код за ориентир). Смяната
     на града нулира улицата и детайлите — улицата зависи от site id. */
  Widget.prototype.onAddrCityInput = function () {
    var self = this;
    this.clearError('addrCity');
    this.state.addrSiteId = null;
    this.state.addrSiteName = null;
    this.state.addrZip = null;
    this.resetAddrStreet();
    var q = this.addrCityInput.value.trim();
    clearTimeout(this.addrCityTimer);
    if (q.replace(/\s/g, '').length < 2) { this.hideList(this.addrCityList, this.addrCityInput); return; }
    this.addrCityTimer = setTimeout(function () { self.searchAddrCities(q); }, 300);
  };

  Widget.prototype.searchAddrCities = function (q) {
    var self = this;
    var seq = ++this.addrCitySeq;
    var url = this.apiBase + '/api/shopify/checkout/sites?store=' + encodeURIComponent(this.store) +
      '&q=' + encodeURIComponent(q) + '&limit=20';
    apiGet(url).then(function (res) {
      if (seq !== self.addrCitySeq) return; // изпреварен от по-нов упит
      // Само реален отказ от Спиди (сигнал от сървъра) пали резервния път —
      // не клиентски network error, не празен резултат (= „няма такъв град").
      if (res && res.error === 'COURIER_UNAVAILABLE') { self.enterAddrFallback(); return; }
      self.renderAddrCities((res && res.sites) || []);
    }).catch(function () { self.renderAddrCities([]); });
  };

  Widget.prototype.renderAddrCities = function (sites) {
    var self = this;
    this.addrCityList.innerHTML = '';
    if (!sites.length) {
      this.addrCityList.appendChild(emptyLi('Няма намерено населено място. Провери изписването.'));
      this.showList(this.addrCityList, this.addrCityInput);
      return;
    }
    sites.forEach(function (s) {
      var li = document.createElement('li');
      li.className = 'marmot-f2__office-item marmot-f2__office-item--row';
      li.setAttribute('role', 'option');
      var nameHtml = escapeHtml(s.name) +
        (s.region ? ' <span class="marmot-f2__office-region">· ' + escapeHtml(s.region) + '</span>' : '');
      li.innerHTML = '<span class="marmot-f2__office-name">' + nameHtml + '</span>' +
        (s.postCode ? '<span class="marmot-f2__office-zip">' + escapeHtml(s.postCode) + '</span>' : '');
      li.addEventListener('click', function () { self.chooseAddrCity(s); });
      self.addrCityList.appendChild(li);
    });
    this.showList(this.addrCityList, this.addrCityInput);
  };

  Widget.prototype.chooseAddrCity = function (s) {
    clearTimeout(this.addrCityTimer); // спри чакащ упит да не преотвори списъка след избора
    this.addrCitySeq++;               // обезсили упит „в полет"
    this.state.addrSiteId = s.siteId;
    this.state.addrSiteName = s.name;
    this.state.addrZip = s.postCode || null;
    this.addrCityInput.value = s.name + (s.postCode ? ' (' + s.postCode + ')' : '');
    this.hideList(this.addrCityList, this.addrCityInput);
    this.clearError('addrCity');
    this.resetAddrStreet();
    if (this.addrStreetField) this.addrStreetField.hidden = false;
    if (this.addrStreetInput) { try { this.addrStreetInput.focus(); } catch (e) {} }
    this.updateStepUI();
  };

  // Нулира улицата/квартала + детайлите (при смяна на града или на метода).
  Widget.prototype.resetAddrStreet = function () {
    clearTimeout(this.addrStreetTimer); // чакащ упит за стария град не бива да
    this.addrStreetSeq++;               // рисува списък под новия (бавна връзка)
    this.state.addrPick = null;
    if (this.addrStreetInput) this.addrStreetInput.value = '';
    if (this.addrStreetField) this.addrStreetField.hidden = true;
    if (this.addrDetails) this.addrDetails.hidden = true;
    this.hideList(this.addrStreetList, this.addrStreetInput);
    this.clearError('addrStreet');
    this.clearError('addrNo');
    this.clearError('addrBlock');
  };

  /* Улица или квартал: пишеш → избираш от двете номенклатури на Спиди за
     избрания град (улици + квартали/комплекси, един слят списък). */
  Widget.prototype.onAddrStreetInput = function () {
    var self = this;
    this.clearError('addrStreet');
    this.clearError('addrNo');    // грешките стоят извън скритата мрежа –
    this.clearError('addrBlock'); // без това остават видими при нов текст
    this.state.addrPick = null;
    if (this.addrDetails) this.addrDetails.hidden = true;
    if (!this.state.addrSiteId) { this.hideList(this.addrStreetList, this.addrStreetInput); return; }
    var q = this.addrStreetInput.value.trim();
    clearTimeout(this.addrStreetTimer);
    if (q.replace(/\s/g, '').length < 2) { this.hideList(this.addrStreetList, this.addrStreetInput); return; }
    this.addrStreetTimer = setTimeout(function () { self.searchAddrStreets(q); }, 300);
  };

  /* Две паралелни заявки; списъкът се рисува, когато и двете приключат. Паднала
     заявка (мрежа, стар бекенд без `checkout/complexes`) е null и не спира другата.
     Кога се отваря резервният път решава L.addrSearchOutcome. */
  Widget.prototype.searchAddrStreets = function (q) {
    var self = this;
    if (!this.state.addrSiteId) return;
    var seq = ++this.addrStreetSeq;
    var query = '?store=' + encodeURIComponent(this.store) +
      '&siteId=' + encodeURIComponent(this.state.addrSiteId) +
      '&q=' + encodeURIComponent(q) + '&limit=' + L.ADDR_LIST_CAP;
    var orNull = function () { return null; };
    Promise.all([
      apiGet(this.apiBase + '/api/shopify/checkout/streets' + query).catch(orNull),
      apiGet(this.apiBase + '/api/shopify/checkout/complexes' + query).catch(orNull)
    ]).then(function (res) {
      if (seq !== self.addrStreetSeq) return; // изпреварен от по-нов упит
      var outcome = L.addrSearchOutcome(res[0], res[1], q);
      if (outcome.fallback) { self.enterAddrFallback(); return; }
      self.renderAddrStreets(outcome.items);
    });
  };

  Widget.prototype.renderAddrStreets = function (items) {
    var self = this;
    this.addrStreetList.innerHTML = '';
    if (!items.length) {
      this.addrStreetList.appendChild(emptyLi('Няма намерена улица или квартал. Провери изписването или града.'));
      this.showList(this.addrStreetList, this.addrStreetInput);
      return;
    }
    items.forEach(function (item) {
      var li = document.createElement('li');
      li.className = 'marmot-f2__office-item';
      li.setAttribute('role', 'option');
      var typ = item.prefix ? '<span class="marmot-f2__office-region">' + escapeHtml(item.prefix) + '</span> ' : '';
      li.innerHTML = '<span class="marmot-f2__office-name">' + typ + escapeHtml(item.name) + '</span>';
      li.addEventListener('click', function () { self.chooseAddrStreet(item); });
      self.addrStreetList.appendChild(li);
    });
    this.showList(this.addrStreetList, this.addrStreetInput);
  };

  Widget.prototype.chooseAddrStreet = function (item) {
    clearTimeout(this.addrStreetTimer); // спри чакащ упит да не преотвори списъка след избора
    this.addrStreetSeq++;               // обезсили упит „в полет"
    this.state.addrPick = item;
    this.addrStreetInput.value = L.addrItemLabel(item);
    this.hideList(this.addrStreetList, this.addrStreetInput);
    this.clearError('addrStreet');
    this.clearError('addrNo');
    this.clearError('addrBlock');
    // Смяна улица ↔ квартал: номерът и блокът от другия вид не се пренасят
    // (иначе „№5" от улицата тихо влиза в адреса на квартала).
    if (this.addrLastKind && this.addrLastKind !== item.kind) {
      ['addr_no', 'addr_block'].forEach(function (n) {
        var el = this.form.querySelector('[name="' + n + '"]');
        if (el) el.value = '';
      }, this);
    }
    this.addrLastKind = item.kind;
    this.applyAddrKind(item.kind);
    if (this.addrDetails) this.addrDetails.hidden = false;
    // Фокусът отива на задължителното поле: номер при улица, блок при квартал.
    var first = this.root.querySelector(item.kind === 'complex' ? '[data-f2-addr-block]' : '[data-f2-addr-no]');
    if (first) { try { first.focus(); } catch (e) {} }
    this.updateStepUI();
  };

  /* Улица: № задължителен. Квартал: блокът е задължителен и излиза пръв в
     мрежата (CSS по data-f2-addr-kind), номерът е по желание. */
  Widget.prototype.applyAddrKind = function (kind) {
    var req = L.addrRequired(kind);
    if (this.addrDetails) this.addrDetails.setAttribute('data-f2-addr-kind', kind);
    var no = this.root.querySelector('[data-f2-addr-no]');
    var block = this.root.querySelector('[data-f2-addr-block]');
    if (no) no.setAttribute('aria-required', req.no ? 'true' : 'false');
    if (block) block.setAttribute('aria-required', req.block ? 'true' : 'false');
  };

  // Номер/блок/вход/етаж/ап. – изчистени, за логиката (L.addrErrors, L.addrLine1).
  Widget.prototype.addrVals = function () {
    return {
      no: this.val('addr_no'),
      block: this.val('addr_block'),
      entrance: this.val('addr_entrance'),
      floor: this.val('addr_floor'),
      apt: this.val('addr_apt')
    };
  };

  // Пълно нулиране на адресните полета (при смяна на метода на доставка).
  Widget.prototype.clearAddressUI = function () {
    this.state.addrSiteId = null;
    this.state.addrSiteName = null;
    this.state.addrZip = null;
    this.state.addrFallback = false;
    this.addrLastKind = null;
    this.resetAddrStreet();
    if (this.addrCityInput) this.addrCityInput.value = '';
    var self = this;
    ['addr_no', 'addr_block', 'addr_entrance', 'addr_floor', 'addr_apt',
      'fb_city', 'fb_zip', 'fb_address1'].forEach(function (n) {
      var el = self.form.querySelector('[name="' + n + '"]');
      if (el) el.value = '';
    });
    // Върни номенклатурния поток, скрий резервния.
    if (this.addrLookup) this.addrLookup.hidden = false;
    if (this.addrFallbackBox) this.addrFallbackBox.hidden = true;
    this.hideList(this.addrCityList, this.addrCityInput);
    this.clearError('addrCity');
    this.clearError('fbCity');
    this.clearError('fbZip');
    this.clearError('fbAddress1');
  };

  /* Резервен път: показва се САМО когато сървърът каже COURIER_UNAVAILABLE (Спиди
     API-то е недостъпно), НЕ като бутон и НЕ при празен резултат. Пренася вече
     въведения град, за да не се губи. Оттук нататък адресът е свободен текст и
     поръчката ще носи белег „Непроверен адрес" (виж buildRequest). */
  Widget.prototype.enterAddrFallback = function () {
    if (this.state.addrFallback) return;
    this.state.addrFallback = true;
    this.state.addrSiteId = null;
    this.state.addrPick = null;
    this.hideAllLists();
    if (this.addrLookup) this.addrLookup.hidden = true;
    if (this.addrFallbackBox) this.addrFallbackBox.hidden = false;
    // Пренеси въведения град (без „(1000)" наставката) в свободното поле.
    var fbCity = this.form.querySelector('[name="fb_city"]');
    if (fbCity && !fbCity.value) {
      var typed = this.state.addrSiteName ||
        (this.addrCityInput ? this.addrCityInput.value.replace(/\s*\(\d+\)\s*$/, '').trim() : '');
      if (typed) fbCity.value = typed;
    }
    var fbZip = this.form.querySelector('[name="fb_zip"]');
    if (fbZip && !fbZip.value && this.state.addrZip) fbZip.value = this.state.addrZip;
    this.updateStepUI();
  };

  // Клавиатура в списък (град или офис): стрелки местят, Enter избира и НЕ подава формата.
  Widget.prototype.onListKeydown = function (e, listEl) {
    if (!listEl) return;
    var items = listEl.querySelectorAll('.marmot-f2__office-item');
    if (e.key === 'Enter') {
      e.preventDefault();
      var active = listEl.querySelector('.marmot-f2__office-item.is-active');
      if (active) active.click();
      return;
    }
    if (!items.length) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      var idx = -1;
      for (var i = 0; i < items.length; i++) { if (items[i].classList.contains('is-active')) { idx = i; break; } }
      var dir = e.key === 'ArrowDown' ? 1 : -1;
      idx = (idx + dir + items.length) % items.length;
      for (var j = 0; j < items.length; j++) items[j].classList.toggle('is-active', j === idx);
      items[idx].scrollIntoView({ block: 'nearest' });
    }
  };

  /* ---- Валидация + подаване ---- */

  Widget.prototype.val = function (name) {
    var el = this.form.querySelector('[name="' + name + '"]');
    return el ? el.value.trim() : '';
  };

  // Валидира само полетата на дадена стъпка (per-step, за да не пуска напред с грешни данни).
  Widget.prototype.validateStep = function (step) {
    var e = {};
    var key = L.stepKey(step, this.hasGiftStep());
    if (key === 'details') {
      if (!this.val('firstName')) e.firstName = 'Въведи име.';
      if (!this.val('lastName')) e.lastName = 'Въведи фамилия.';
      var email = this.val('email');
      if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) e.email = 'Въведи валиден имейл.';
      if (!L.normalizePhone(this.val('phone'))) e.phone = 'Въведи валиден български телефон.';
      var invoiceToggle = this.root.querySelector('[data-f2-invoice-toggle]');
      if (invoiceToggle && invoiceToggle.checked) {
        if (!this.val('company_name')) e.company_name = 'Въведи фирма.';
        if (!this.val('uic')) e.uic = 'Въведи ЕИК.';
        if (!this.val('vat')) e.vat = 'Въведи ДДС номер.';
        if (!this.val('company_address')) e.company_address = 'Въведи адрес на фирмата.';
      }
    } else if (key === 'delivery') {
      if (!this.methodSelected()) e.method = 'Избери метод на доставка.';
      else if (this.state.service === 'office') {
        if (!this.state.cityName) e.officeCity = 'Избери град от списъка.';
        else if (!this.state.officeId) {
          var lockerTexts = L.officeTexts(this.state.courier);
          e.office = lockerTexts ? lockerTexts.required : 'Избери офис от списъка.';
        }
      }
      else if (this.state.service === 'address') {
        if (this.state.addrFallback) {
          if (!this.val('fb_city')) e.fbCity = 'Въведи град.';
          if (!this.val('fb_zip')) e.fbZip = 'Въведи пощенски код.';
          if (this.val('fb_address1').length < 6) e.fbAddress1 = 'Въведи пълен адрес.';
        } else {
          var addrErr = L.addrErrors(this.state.addrPick, !!this.state.addrSiteId, this.addrVals());
          for (var ak in addrErr) e[ak] = addrErr[ak];
        }
      }
    } else if (key === 'review') {
      var terms = this.root.querySelector('[data-f2-terms]');
      if (!terms || !terms.checked) e.terms = 'Приеми общите условия.';
    }
    return e;
  };

  // Показва грешките; връща true, ако е имало (и не бива да се продължава).
  Widget.prototype.showErrors = function (errors) {
    var names = Object.keys(errors);
    if (!names.length) return false;
    for (var i = 0; i < names.length; i++) this.setError(names[i], errors[names[i]]);
    var firstField = this.form.querySelector('[data-f2-error="' + names[0] + '"]');
    // Грешка, която не стои веднага след полето си, сочи го с data-f2-error-for.
    var forId = firstField && firstField.getAttribute('data-f2-error-for');
    var focusEl = forId ? document.getElementById(forId) : firstField && firstField.previousElementSibling;
    if (focusEl && focusEl.focus) {
      try { focusEl.focus(); } catch (e) {}
    }
    return true;
  };

  Widget.prototype.submit = function () {
    if (this.state.submitting) return;
    /* Втори натиск след бележката „подаръкът свърши“: поръчката съществува,
       остава само пренасочването. Сверката на тялото пази от плащане по данни,
       които човекът е сменил, след като бележката е излязла. */
    if (this.state.readyInvoiceUrl && JSON.stringify(this.buildRequest()) === this.state.readyBody) {
      this.setSubmitting(true);
      if (this.ctaLabel) this.ctaLabel.textContent = 'Пренасочваме…';
      window.location.href = this.state.readyInvoiceUrl;
      return;
    }
    this.state.readyInvoiceUrl = null;
    this.state.readyBody = null;
    this.hideGiftGone();
    this.clearAllErrors();
    // Защитно: пълна валидация на всички съществуващи стъпки преди draft.
    var all = {};
    var hasGift = this.hasGiftStep();
    for (var s = 1; s <= L.totalSteps(hasGift); s++) {
      var errs = this.validateStep(s);
      for (var k in errs) all[k] = errs[k];
    }
    if (Object.keys(all).length) {
      // Върни на първата стъпка с грешка, за да я поправи.
      // И редът, и картата поле → стъпка живеят в логическия модул: поле, добавено
      // само на едното място, връща човека на „Потвърждение" и грешката, която го
      // е спряла, става невидима. Един тест пази двете да не се разминават.
      var order = L.fieldOrder;
      var firstStep = L.stepNumber('review', hasGift);
      for (var j = 0; j < order.length; j++) {
        if (all[order[j]]) { firstStep = L.stepOfField(order[j], hasGift) || firstStep; break; }
      }
      if (firstStep !== this.state.step) this.goToStep(firstStep);
      this.showErrors(all);
      return;
    }

    var self = this;
    this.setSubmitting(true);
    if (!L.cartHasLines(this.state.cart)) {
      // Без количка заявката би тръгнала с `lines: []` и сървърът я отказва.
      // Пробваме още веднъж; не стане ли, казваме какво да се направи.
      this.state.cartReloading = false;
      var opit = this.reloadMissingCart() || Promise.resolve();
      opit.then(function () {
        if (!L.cartHasLines(self.state.cart)) {
          self.setSubmitting(false);
          self.showFormError(ERROR_MESSAGES.CART_UNAVAILABLE);
          return;
        }
        self.postDraft(self.buildRequest(), true);
      });
      return;
    }
    this.postDraft(this.buildRequest(), true);
  };

  Widget.prototype.postDraft = function (body, allowKeyRetry) {
    var self = this;
    if (!this.state.idempotencyKey) this.state.idempotencyKey = uuid();
    apiPost(this.apiBase + '/api/shopify/checkout/draft', body, {
      'Idempotency-Key': this.state.idempotencyKey
    }).then(function (res) {
      if (res && res.invoiceUrl) {
        /* Подаръкът е свършил между показването и плащането: сървърът е приел
           поръчката БЕЗ него и го казва с giftApplied. Поръчката не се проваля —
           но и не бива да пренасочваме тихо, защото човек, обещан подарък, ще го
           открие чак в потвърждението. Показваме бележка и оставяме следващия
           натиск да пренасочи към същия, вече създаден draft.
           Условието пита какво сме ПОИСКАЛИ: без избор giftApplied е false по
           дефиниция и съобщението би излязло на всяка поръчка без подарък. */
        if (body.giftVariantId && res.giftApplied !== true) {
          self.showGiftGone(res.invoiceUrl);
          return;
        }
        if (self.ctaLabel) self.ctaLabel.textContent = 'Пренасочваме…';
        window.location.href = res.invoiceUrl;
        return;
      }
      self.setSubmitting(false);
      self.showFormError(ERROR_MESSAGES.SERVER_ERROR);
    }).catch(function (err) {
      if (err && err.code === 'IDEMPOTENCY_CONFLICT' && allowKeyRetry) {
        self.state.idempotencyKey = uuid();
        self.postDraft(body, false);
        return;
      }
      self.setSubmitting(false);
      var lockerTexts = L.officeTexts(body.courier);
      var lockerMsg = lockerTexts && err && (
        err.code === 'OFFICE_NOT_FOUND' ? lockerTexts.notFound :
          err.code === 'OFFICE_CACHE_EMPTY' ? lockerTexts.cacheEmpty : null);
      var msg = lockerMsg || (err && err.code && ERROR_MESSAGES[err.code]) ||
        (err && err.network ? ERROR_MESSAGES.NETWORK : null) ||
        (err && err.rateLimited ? ERROR_MESSAGES.RATE_LIMITED : null) ||
        ERROR_MESSAGES.SERVER_ERROR;
      self.showFormError(msg);
    });
  };

  /* ---- Общо тяло за проверката на код и draft заявката (контрактът срещу #D774) ---- */
  Widget.prototype.buildRequest = function () {
    var cart = this.state.cart || { items: [], attributes: {} };
    var lines = (cart.items || []).map(function (it) {
      return {
        variant_id: it.variant_id || it.id,
        quantity: it.quantity,
        final_price: it.final_price,
        final_line_price: it.final_line_price,
        title: it.title,
        properties: it.properties && Object.keys(it.properties).length ? it.properties : undefined
      };
    });
    var invoiceToggle = this.root.querySelector('[data-f2-invoice-toggle]');
    var invoiceRequested = !!(invoiceToggle && invoiceToggle.checked);

    var body = {
      store: this.store,
      lines: lines,
      attributes: cart.attributes && Object.keys(cart.attributes).length ? cart.attributes : undefined,
      discountCodes: readCartDiscountCodes(cart),
      promoCode: this.state.promo || undefined,
      firstName: this.val('firstName'),
      lastName: this.val('lastName'),
      email: this.val('email'),
      phone: L.normalizePhone(this.val('phone')),
      invoiceRequested: invoiceRequested,
      courier: this.state.courier,
      service: this.state.service,
      acceptedTerms: true,
      widgetConfigVersion: CONFIG_VERSION
    };
    // Подаръкът е отделен договорен избор: не променя количката, сумите или lines.
    if (/^\d+$/.test(String(this.state.giftVariantId || ''))) {
      body.giftVariantId = this.state.giftVariantId;
    }
    if (invoiceRequested) {
      body.company_name = this.val('company_name');
      body.uic = this.val('uic');
      body.vat = this.val('vat');
      body.company_address = this.val('company_address');
    }
    if (this.state.service === 'office') {
      body.officeId = this.state.officeId;
    } else if (this.state.addrFallback) {
      // Резервен път: свободен текст + белег „Непроверен адрес" за оператора във
      // Ф1. Белегът язди СЪЩЕСТВУВАЩИЯ attributes канал → draft контрактът и
      // тестът срещу #D774 НЕ се пипат (офис/нормалният адрес не носят белег).
      body.city = this.val('fb_city');
      body.zip = this.val('fb_zip');
      body.address1 = this.val('fb_address1');
      body.attributes = withUnverifiedAddress(body.attributes);
    } else {
      // Контрактът с бекенда е непроменен: град/пощ.код/address1 (Ф1 чете address1).
      // При квартал Ф1 разпознава комплекса и блока от текста (част А).
      // Номерата на Спиди (f2_*) яздят attributes – cartFingerprint не ги
      // включва, затова draft контрактът срещу #D774 остава същият.
      var vals = this.addrVals();
      body.city = this.state.addrSiteName || '';
      body.zip = this.state.addrZip || '';
      body.address1 = L.addrLine1(this.state.addrPick, vals);
      if (this.state.courier === 'speedy') {
        body.attributes = L.withAddrAttributes(body.attributes,
          L.addrAttributes(this.state.addrSiteId, this.state.addrPick, vals));
      }
    }
    return body;
  };

  Widget.prototype.setSubmitting = function (on) {
    this.state.submitting = on;
    if (this.cta) { this.cta.disabled = on; this.cta.classList.toggle('is-loading', on); }
    if (this.ctaLabel) this.ctaLabel.textContent = on
      ? 'Обработваме…'
      : L.ctaLabel(this.state.step, this.methodSelected(), this.hasGiftStep());
  };

  /* ---- Грешки ---- */
  Widget.prototype.setError = function (name, msg) {
    var el = this.form.querySelector('[data-f2-error="' + name + '"]');
    if (el) { el.textContent = msg; el.classList.add('is-visible'); }
  };
  Widget.prototype.clearError = function (name) {
    var el = this.form.querySelector('[data-f2-error="' + name + '"]');
    if (el) { el.textContent = ''; el.classList.remove('is-visible'); }
  };
  Widget.prototype.clearAllErrors = function () {
    var els = this.form.querySelectorAll('[data-f2-error]');
    Array.prototype.forEach.call(els, function (el) { el.textContent = ''; el.classList.remove('is-visible'); });
    if (this.formError) { this.formError.hidden = true; this.formError.textContent = ''; }
  };
  Widget.prototype.showFormError = function (msg) {
    if (!this.formError) return;
    this.formError.hidden = false;
    this.formError.textContent = msg;
  };

  /* ---- Помощни ---- */

  function apiGet(url) {
    return fetch(url, { method: 'GET', mode: 'cors', credentials: 'omit', headers: { 'Accept': 'application/json' } })
      .then(handleResponse);
  }
  function apiPost(url, body, extraHeaders) {
    var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    if (extraHeaders) for (var k in extraHeaders) headers[k] = extraHeaders[k];
    return fetch(url, { method: 'POST', mode: 'cors', credentials: 'omit', headers: headers, body: JSON.stringify(body) })
      .then(handleResponse);
  }
  function handleResponse(r) {
    if (r.status === 429) return r.json().catch(function () { return {}; }).then(function () { throw { rateLimited: true }; });
    return r.json().catch(function () { throw { network: true }; }).then(function (data) {
      if (!r.ok) throw { code: (data && data.error) || 'SERVER_ERROR', status: r.status };
      return data;
    });
  }

  function readCartDiscountCodes(cart) {
    if (cart && Array.isArray(cart.discount_codes)) {
      var codes = cart.discount_codes
        .filter(function (d) { return d && d.applicable && d.code; })
        .map(function (d) { return d.code; });
      return codes.length ? codes : undefined;
    }
    return undefined;
  }

  // Добавя белег „Непроверен адрес" към cart атрибутите (обект или масив →
  // връща обект). Ползва се само по резервния път; бекендът вече прекарва
  // attributes през customAttributes, затова draft контрактът не се пипа.
  function withUnverifiedAddress(attributes) {
    var out = {};
    if (Array.isArray(attributes)) {
      attributes.forEach(function (a) { if (a && a.name != null) out[a.name] = a.value; });
    } else if (attributes && typeof attributes === 'object') {
      for (var k in attributes) {
        if (Object.prototype.hasOwnProperty.call(attributes, k)) out[k] = attributes[k];
      }
    }
    out['Непроверен адрес'] = 'Да';
    return out;
  }

  function plural(n, one, few, many) {
    if (n === 1) return one;
    return n >= 2 && n <= 4 ? few : many;
  }

  function emptyLi(text) {
    var li = document.createElement('li');
    li.className = 'marmot-f2__office-empty';
    li.textContent = text;
    return li;
  }

  function setText(root, sel, txt) {
    var el = root.querySelector(sel);
    if (el) el.textContent = txt;
  }
  function show(el) { if (el) el.hidden = false; }
  function hide(el) { if (el) el.hidden = true; }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function getF2SessionId() {
    if (memoryF2SessionId) return memoryF2SessionId;
    try {
      var stored = sessionStorage.getItem('marmot_f2_session');
      if (stored) {
        memoryF2SessionId = stored;
        return memoryF2SessionId;
      }
      memoryF2SessionId = uuid();
      sessionStorage.setItem('marmot_f2_session', memoryF2SessionId);
    } catch (e) {
      if (!memoryF2SessionId) memoryF2SessionId = uuid();
    }
    return memoryF2SessionId;
  }

  function uuid() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  // Носещ маркер за функционалния договорен тест; не го преименувай без обновяване на харнеса.
  /* ---- Bootstrap ---- */
  function boot() {
    var el = document.getElementById('marmot-f2');
    if (el) init(el);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
